import React, { useEffect } from "react";
import Common_title from "../common-components/common-title/Common_title";

const Refund_Policy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="Privacy_policy">
      <div className="container">
        <Common_title subtitle="Refund & Cancellation Policy" />

        <div className="white_card">
          <div className="refund-policy">
            <p className="point_title">
              Refund & Cancellation Policy for Loconex App
            </p>
            <p className="point_title">Effective Date: 29.04.2026</p>
            <p className="point_title">1. General Policy</p>
            <p className="descn_text">
              Loconex acts as a platform connecting customers and vendors.
              Refunds and cancellations are primarily handled by the respective
              vendors.
            </p>
            <p className="point_title">2. Cancellation</p>
            <p className="descn_text">
              Orders can be cancelled before they are accepted or processed by
              the vendor Once the order is processed or shipped, cancellation
              may not be possible
            </p>
            <p className="point_title">3. Refund Eligibility</p>
            <p className="descn_text">
              Refunds may be applicable in the following cases:
            </p>
            <ul className="descn_text">
              <li>Product/service not delivered</li>
              <li>Wrong product delivered</li>
              <li>Damaged or defective product</li>
              <li>Duplicate payment</li>
            </ul>
            <p className="point_title">4. Refund Process</p>
            <ul className="descn_text">
              <li>Users must raise a request within [2–5 days] of delivery</li>
              <li>Refund requests will be reviewed and verified</li>
              <li>
                Approved refunds will be processed to the original payment
                method
              </li>
            </ul>
            <p className="point_title">5. Refund Timeline</p>
            <p className="descn_text">
              Refunds are typically processed within 5–10 business days Time may
              vary depending on the payment provider
            </p>
            <p className="point_title">6. Non-Refundable Cases</p>

            <ul className="descn_text">
              <li>Change of mind after delivery</li>
              <li>Minor differences in product appearance</li>
              <li>Services already completed</li>
            </ul>
            <p className="point_title">7. Vendor Responsibility</p>
            <p className="descn_text">
              Vendors are responsible for honoring valid refund requests.
              Loconex may assist in dispute resolution but is not liable for
              vendor decisions.
            </p>
            <p className="point_title">8. Contact for Refund</p>
            <p className="descn_text">Phone: +91 6262171723</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Refund_Policy;
